import React from 'react'
import {TeamSummaryCard} from "./cards/TeamSummary";
import {useBodyColor} from "../hooks";
import MobilePage from "../components/MobilePage";
import {GameInfoCard} from "./cards/Games";


export default ({ teamId, clearTeamId }) => {
  useBodyColor('#ECF7FE')

  return (
    <MobilePage
      wrapContentInCards={false}
    >
      <div>
        <TeamSummaryCard teamId={teamId} clearTeamId={clearTeamId} />
        <GameInfoCard teamId={teamId} />
      </div>
    </MobilePage>
  )
}
